import angular from 'angular';

const limitedIcon = angular.module('limitedIcon', ['limitedIconTemplate']);

export default limitedIcon;
